import { LearnMore } from '../LearnMore';
import { TourActivityChart } from './TourActivityChart';
import { ToursSessionBreakdown } from './ToursSessionBreakdown/ToursSessionBreakdown';
import { ToursTable } from './ToursTable';
import { ToursTotalVisits } from './ToursTotalVisits';

export const ToursDashboard = () => (
  <div className="w-ds-page grid grid-cols-[minmax(340px,400px),_1fr] grid-rows-[405px,repeat(3,_min-content)] gap-6 pt-9 items-stretch">
    <ToursTotalVisits />
    <TourActivityChart />
    <div className="col-span-full">
      <ToursTable />
    </div>
    <div className="col-span-full">
      <ToursSessionBreakdown />
    </div>
    <div className="col-span-full">
      <LearnMore />
    </div>
  </div>
);
